import React from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import Button from './components/Button';
import Table from './components/Table';
import Tabs from './components/Tabs';
import Badge from './components/Badge';

const DashboardContainer = styled.div`
  font-family: 'Arial', sans-serif;
  background-color: #f4f4f4;
  margin: 0;
  padding: 0;
  min-height: 100vh;
`;

const Title = styled.h2`
  color: #5A6B7B;
  text-align: center;
  margin-top: 20px;
  font-size: 24px;
  font-weight: bold;
`;

const SubHeader = styled.div`
  text-align: center;
  font-size: 18px;
  color: #4F728F;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
  flex-wrap: wrap;
  padding: 0 20px;
`;

const BadgeContainer = styled.div`
  text-align: center;
  margin-top: 15px;
  margin-bottom: 30px;
`;

const Dashboard: React.FC = () => {
  const tableColumns = [
    'Origin',
    'Destination',
    'Equipment',
    'Miles',
    'Line Haul',
    'Margin',
    'FSC'
  ];

  const tableData = [
    ['Tallapoosa, GA 30176', 'Norcross, GA 30093', 'Van', '77', '$498', '$50', '$39'],
    ['Tallapoosa, GA 30176', 'Baton Rouge, LA 70809', 'Van', '491', '$2763', '$276', '$246'],
    ['Dallas, TX 75201', 'Houston, TX 77001', 'Flatbed', '239', '$1200', '$100', '$75']
  ];

  const tabs = [
    {
      id: 'table',
      label: 'Table View',
      content: <Table columns={tableColumns} data={tableData} />
    },
    {
      id: 'analytics',
      label: 'Analytics',
      content: (
        <div>
          <h3>Analytics Section</h3>
          <p>Coming soon...</p>
        </div>
      )
    }
  ];

  return (
    <DashboardContainer>
      <Header logoUrl="/logo.png" title="EureekaBI Dashboard" />
      <Title>Dashboard Overview</Title>
      <SubHeader>Manage your pricing and workflow efficiently</SubHeader>
      
      <ButtonContainer>
        <Button variant="primary">Work Offline</Button>
        <Button variant="secondary">Alter RFP</Button>
        <Button variant="success">Success</Button>
        <Button variant="danger">Danger</Button>
        <Button variant="minimal">Minimal</Button>
        <Button disabled>Disabled</Button>
      </ButtonContainer>

      <Tabs tabs={tabs} defaultTab="table" />

      <BadgeContainer>
        <Badge variant="pending">Pending</Badge>
        <Badge variant="active">Active</Badge>
        <Badge variant="complete">Complete</Badge>
      </BadgeContainer>
    </DashboardContainer>
  );
};

export default Dashboard; 